/* eslint-disable */
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, PopoverController } from '@ionic/angular';
import { DateTimeService } from 'src/app/services/date-time/date-time.service';
import { LoggerService } from 'src/app/services/logger.service';
import { PosterService } from 'src/app/services/poster.service';
import { PrefsService } from 'src/app/services/prefs.service';
import { environment } from 'src/environments/environment';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss']
})
export class ContactPage implements OnInit {
  // data passed from signup-detail
  accessCode: string; // prepopulate form field if available
  email: string; // prepopulate form field if available
  isModal: any;

  // other form fields
  name: any;
  feedback: any;

  studyId: any;

  showAccessCode = false;
  feedbackSubmitError = false;
  formInvalid = false;
  requestFailed = false;
  invalidEmail = false;

  constructor(
    private modalCtrl: ModalController,
    private popoverCtrl: PopoverController,
    private alertCtrl: AlertController,
    private logger: LoggerService,
    private dateTime: DateTimeService,
    private http: HttpClient,
    private prefs: PrefsService,
    private poster: PosterService
  ) {}

  async presentAlertRequestSent() {
    return new Promise(async (resolve, reject) => {
      const alert = await this.alertCtrl.create({
        // cssClass: 'my-custom-class',
        header: 'Successfully sent',
        // subHeader: 'Subtitle',
        message: "Thanks. We'll contact you shortly.",
        buttons: [
          {
            text: 'OK',
            handler: () => resolve(null)
          }
        ]
      });

      await alert.present();
    });
  }

  resetValidation() {
    this.feedbackSubmitError = false;
    this.invalidEmail = false;
    this.requestFailed = false;
    this.formInvalid = false;
  }

  submit() {
    const nowSeconds = this.dateTime.getNowSeconds();
    const URL = 'https://rsginchelp.zendesk.com/api/v2/requests';
    const re = /^\S+@\S+\.\S+$/; // using a short re to make sure basic parts are present; not bullet-proof (see http://stackoverflow.com/questions/46155/validate-email-address-in-javascript)

    this.resetValidation();

    if (!this.email || !this.name || !this.feedback) {
      this.feedbackSubmitError = true;
      this.formInvalid = true;
      return;
    }

    if (!re.test(this.email)) {
      this.feedbackSubmitError = true;
      this.invalidEmail = true;
      return;
    }

    const data = {
      request: {
        subject: this.feedback,
        tags: [environment.browserAppConfig.appId],
        via_id: 48,
        comment: {
          body: this.feedback,
          uploads: []
        },
        requester: {
          name: this.name,
          email: this.email,
          locale_id: 1
        },
        ticket_form_id: '360001520854',
        fields: {
          360024407814: this.studyId,
          360025788573: this.accessCode
        }
      }
    };

    this.http.post(URL, data).subscribe(
      (res) => {
        this.logger.log('Posting ZenDesk', MSRemoteLoggerCategory.SETUP_CONTACT_PAGE);
        const nowSeconds = this.dateTime.getNowSeconds();
        // send to zendesk, but also send to server
        // this.poster.addThenSend('/feedback', { feedback: this.feedback, created: nowSeconds });
        this.feedback = '';
        this.presentAlertRequestSent().then(() => {
          this.dismiss();
        });
      },
      (err) => {
        //ERROR HANDLER PROVIDER
        this.feedbackSubmitError = true;
        this.requestFailed = true;

        /*
                IF WE HAVE A FAILED REQUEST (THEY DON'T HAVE INTERNET/HAVE A BAD CONNECTION)
                WE ARE GOING TO ADD THE FEEDBACK TO THE POSTER TO BE SENT UP TO THE SERVER (NOT ZENDESK) AT A LATER POINT
                */
        this.logger.error(`Zendesk Submit Failed. Status: ${err.status} Data: ${err.data}`, MSRemoteLoggerCategory.SETUP_CONTACT_PAGE);
      }
    );
  }

  dismiss() {
    if (this.isModal) {
      this.modalCtrl.dismiss();
    } else {
      this.popoverCtrl.dismiss();
    }
  }

  init() {
    // console.log('ionViewDidLoad FeedbackZendeskPage');
    this.prefs.getPromises('authCode', 'studyId').then((results) => {
      // if we don't have a studyId yet, just make it an empty string.
      // when we send to zendesk, empty studyId goes to a generic mailbox
      this.accessCode = results[0] === null ? '' : results[0];
      if (results[0] == null) {
        this.showAccessCode = true;
      }
      this.studyId = results[1] === null ? '' : results[1];
    });
  }

  ionViewWillEnter() {
    this.init();
  }

  ngOnInit() {}
}
